import { http } from 'common/helpers/axios/axios-helper';
import { RegionsModel as Model } from '../model/regions.model';
import { StatusFilter } from 'common/types/status-filter.model';

const basePath = '/region';

async function getDataList(status: StatusFilter) {
  const queryParams = [];

  if (status !== undefined && status !== '') {
    queryParams.push(`IsActive=${status}`);
  }

  const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : '';
  return await http.get<Model[]>(`${basePath}${queryString}`);
}

async function getDataById(id: any) {
  return await http.get<Model>(`${basePath}/${id}`);
}

export const RegionsService = { getDataList, getDataById };
